import murrayPic from "@/public/images/artists/murray.png";
import { Artist } from "@/types/types";

export const murray = {
  id: "145",
  name: "Murray",
  image: murrayPic,
  description: `Murray's voice has a low, full-bodied timbre that conveys authority and warmth. Its smooth, commanding presence is complemented by an expressive range, allowing it to effortlessly communicate both subtle emotions and powerful intensity.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fmurray-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: [
        "Jazz",
        "Country",
        "Soul",
        "Blues",
        "Pop",
        "Dance",
        "Unprocessed",
        "Deep",
      ],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Bass",
        high: "Low",
      },
      specific: {
        low: 45,
        high: 66,
      },
      sweetSpot: 57,
    },
  },
} as const satisfies Artist;
